import { Link } from 'react-router-dom'
import classnames from 'utils/classnames'
import routes from 'routes'

const Navigation = () => {
    const topLinkClassnames = (sub) => {
        return classnames(
            'px-4 py-7 block transition-colors duration-300 hover:bg-slate-300',
            {
                'border-t border-l border-r group-hover:border-black': sub
            }
        )
    }

    return (
        <nav>
            <ul className="flex reset">
                {
                    routes.map(({ label, path, sub }, idx) => (
                        <li key={idx} className="relative group">
                            <Link to={path} className={topLinkClassnames(sub)}>
                                { label }
                            </Link>

                            {
                                sub?.length > 0 && (
                                    <div className="absolute bottom-0 left-0 bg-slate-100 border-l border-r border-b border-black translate-y-full w-full scale-y-0 group-hover:scale-y-100 transition-transform duration-300 ease-in-out origin-top">
                                        <ul className="reset">
                                            {
                                                sub.map((subRoute, jdx) => (
                                                    <li key={`sub-route-${idx}-${jdx}`}>
                                                        <Link to={subRoute.path} className="px-4 py-7 block transition-colors duration-300 hover:bg-slate-300">
                                                            { subRoute.label }
                                                        </Link>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                )
                            }
                        </li>
                    ))
                }
            </ul>
        </nav>
    )
}

export default Navigation